import { API } from 'aws-amplify';
import { AuthorizeData } from '../types';
import { normalizeAgentUsernames } from './normalize-usernames';

/** React Query key shared by every Contracting /authorize query in the app */
export const AUTHORIZE_QUERY_KEY = ['ContractingAPI', '/authorize'];

/**
 * Fetch the signed-in user's Agent or Staff record and IMO from the
 * Contracting API. This is the same call dmd-contracting-web makes. It feeds
 * the App Bar user control, the user menu and System Screens, and its
 * `Agent.HasTecCC` tells Dashboard whether Contracting's onboarding is done.
 */
export async function fetchAuthorize() {
  const response: { data: AuthorizeData } = await API.post(
    'ContractingAPI',
    '/authorize',
    {},
  );
  return normalizeAgentUsernames(response.data);
}
